import React from "react";
import styled from "styled-components";
import {
  ToastContainer as ToastifyToastContainer,
  toast as toastifyToast,
} from "react-toastify";
import { ToastOptions } from "react-toastify/dist/types";
import "react-toastify/dist/ReactToastify.min.css";
import { ReactComponent as ErrorIcon } from "assets/icons/outlined-cross.svg";
import { ReactComponent as SuccessIcon } from "assets/icons/outlined-correct.svg";
import ToastContent from "./ToastContent";

const StyledToastContainer = styled(ToastifyToastContainer)`
  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.colors.danger};
  }

  .Toastify__toast--success {
    background-color: ${({ theme }) => theme.colors.success};
  }

  .Toastify__close-button > svg {
    color: ${({ theme }) => theme.colors.grayScale.darkest};
  }

  .Toastify__toast-body {
    padding: 10px;
  }
`;

interface ToastMethodProps {
  title?: string;
  text: string;
  options?: ToastOptions;
}

export const errorToast = ({ title = "Erro", text, options = {} }: ToastMethodProps) =>
  toastifyToast.error(
    <ToastContent title={title} text={text} icon={<ErrorIcon />} />,
    options,
  );

export const successToast = ({
  title = "Sucesso",
  text,
  options = {},
}: ToastMethodProps) =>
  toastifyToast.success(
    <ToastContent title={title} text={text} icon={<SuccessIcon />} />,
    options,
  );

const ToastContainer = () => {
  return <StyledToastContainer icon={false} />;
};

export default ToastContainer;
